import React from "react";
import axios from "axios";

import { API_URL } from "../config/apiUrls";
import { getToken } from "../components/common/common";

const PostRequest = async (path, data = {}, isFileUpload = false) => {
  console.log(`${API_URL}${path}`);
  const token = getToken();
  var headers = { "content-type": "application/json" };

  if (isFileUpload) {
    headers = { "content-type": "multipart/form-data" };
  }
  headers.authorization = token;

  try {
    const response = await axios.post(`${API_URL}${path}`, data, {
      headers: headers,
      crossDomain: true,
    });

    const responseData = response.data;
    console.log('apiData', responseData)

    if (responseData.code === 200) {
      return responseData.data;
    } else {
      if (responseData?.code == 401) {
        window.location.href = "/login";
        return false;
      }

      alert(responseData.data);
      return false;
    }
  } catch (error) {

    if(error?.response?.status == 401) {
      window.localStorage.clear();
      window.location.href = "/login";
      return false;
    }

    alert(error);
    
    return false;
  }
};

export default PostRequest;
